module.exports = __webpack_public_path__ + "img/gys_3@2x.88784da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_3@2x.png
// module id = eBif
// module chunks = 0